import React, { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css';
import './index.scss';
import kitechLogo from './assets/white_transparent.png';
import { GlobalProvider } from './context/GlobalState';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/en-gb';
import { ConfigProvider } from 'antd';
import enGB from 'antd/lib/locale/en_GB';

// Set moment global locale to en-gb (starts week on Monday)
moment.locale('en-gb');

const App = React.lazy(() => import('./App'));

// Replace the LoadingOutlined with a custom KiTech logo component
const KiTechLogo = () => (
  <div className="logo-spinner">
    <img 
      src={kitechLogo} 
      alt="KITECH Logo" 
      style={{ 
        width: '80px',
        height: 'auto',
        animation: 'spin 3s linear infinite'
      }} 
    />
    <style>{`
      @keyframes spin {
        0% { transform: rotateY(0deg); }
        100% { transform: rotateY(360deg); }
      }
      .logo-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `}</style>
  </div>
);

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  backgroundColor: '#3399ff',
  color: 'white'
}



const container = document.getElementById('root') as HTMLElement;
const AppContent = (
    <BrowserRouter>
      <ConfigProvider locale={enGB}>
        <Suspense fallback={<div style={style}><KiTechLogo /></div>}>
          <GlobalProvider>
            <App />
          </GlobalProvider>
        </Suspense>
      </ConfigProvider>
    </BrowserRouter>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, AppContent);
} else {
  const root = createRoot(container);
  root.render(AppContent);
}


// src/index.js or src/App.js

// Register the service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
